import React, { useState } from "react";
import DataTable from "../../../UI/table/DataTable";
import StatusBadge from "../../../UI/statusBadge";
import TableActions from "../../../UI/table/TableActions";
import ShiftsModal from "./shiftmodal";
import { deleteCuriosShifts, getCuriosShifts } from "../../../../MyApi/curior";
import { useQuery } from "react-query";

const CuriorShift = ({ refetch, id, storeId }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [current_page, setCurrentPage] = useState(1);

  const {
    data,
    isLoading,
    refetch: refetchCouier,
  } = useQuery(["getcouriers", current_page], () => getCuriosShifts(id));

  const shifts = data?.data?.templates || [];
  console.log("shifts", shifts);

  const total = data?.data?.pagination?.total || 0;
  const per_page = data?.data?.pagination?.last_page;
  const curiorShifts = [
    { label: "موعد العمل", accessor: "name" },
    { label: "التاريخ", accessor: "created_at" },
    {
      label: "مرن",
      render: (row) => (
        <StatusBadge
          status={row.is_flexible ? "active" : "inactive"}
          statusLabel={row.is_flexible ? "مرن" : "غير مرن"}
        />
      ),
    },
    {
      label: "الحالة",
      render: (row) => (
        <StatusBadge status={row.is_active ? "active" : "inactive"} />
      ),
    },
{
  label: "الإجراءات",
  render: (row) => (
    <TableActions
      deleteFn={(shiftId) => deleteCuriosShifts(id, shiftId)}
      id={row.id}
      mutationKey={["deleteCuriorShift", row.id]}
      queryKey={"getcouriers"}
      deletePermission={"delete_couier_shift"}
    />
  ),
},
  ];

  const openModal = () => {
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div>
      {isModalOpen && (
        <ShiftsModal
          isOpen={isModalOpen}
          closeModal={closeModal}
          id={id}
          refetch={refetchCouier}
          storeId={storeId}
        />
      )}
      <DataTable
        title={"مواعيد العمل"}
        columns={curiorShifts}
        actionLabel={"تعيين موعد عمل "}
        onAddClick={() => openModal()}
        data={shifts}
        totalItems={total}
        setCurrentPage={setCurrentPage}
        currentPage={current_page}
        itemsPerPage={per_page}
        isLoading={isLoading}
        createPermission={"create_couier_shift"}
      />
    </div>
  );
};

export default CuriorShift;
